import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const ClockXIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      width="24"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.375 14.25L12 13.125V8.42087M21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C12.5768 21 13.1409 20.9457 13.6875 20.8421M21.125 16.375L19.3125 18.1875M19.3125 18.1875L17.5 20M19.3125 18.1875L21.125 20M19.3125 18.1875L17.5 16.375"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
};

ClockXIcon.displayName = 'ClockXIcon';
